import React from 'react'
import * as Yup from 'yup'

const formView = (defaultValues, value) => [
  {
    name: 'profile',
    label: 'Select Product',
    placeholder: 'Select product',
    type: 'Select',
    list: value?.productList,
    features: {
      formatOptionLabel: ({ label, value, variant, sections, product }) => (
        <div className={'flex flex-row gap-[12px] items-center h-[100%]'}>
          <span className={'!w-[60px]  object-cover overflow-hidden flex flex-col justify-center items-center  '}>
            {product?.['2d_image_url'] ? (
              <img src={product?.['2d_image_url']} className={'!h-[60px] !w-[60px] object-cover'} />
            ) : (
              <div className={'w-[60px] h-[60px] bg-gray-200 rounded-sm'}></div>
            )}
          </span>
          <div className={'flex flex-col gap-0 w-[calc(100%-72px)]'}>
            <span className={'text-text-md truncate'}>{product?.name}</span>
            <span className={'text-text-md truncate text-gray-400'}>
              {variant} (sections: {sections})
            </span>
          </div>
        </div>
      ),
      //menuIsOpen: true
    },
    style: {
      option: {
        height: '80px !important', // same as control height
        padding: '5px 0px',
      },
    },
    className: 'col-span-12 row-span-1',
    labelClassName: 'hidden',
    innerClassName: '!h-[120px]',
    menuPortalTarget: 'false',
    validation: Yup.string().required('Select product to clone from'),
  },
  {
    name: 'productList',
    type: 'Hidden',
    defaultValue: [],
  },
  {
    name: 'clone_product_profile',
    label: 'Clone Product Profile',
    type: 'Checkbox',
    className: 'col-span-12 row-span-1 bg-white !px-0',
    labelClassName: 'hidden',
    defaultValue: defaultValues?.is_apply_smoothing || false,
    clear: false,
    reset: false,
    condition: (value) => value.product,
  },
  {
    name: 'clone_shape_profile',
    label: 'Clone Shape Profile',
    type: 'Checkbox',
    className: 'col-span-12 row-span-1 bg-white !px-0',
    labelClassName: 'hidden',
    defaultValue: defaultValues?.is_apply_smoothing || false,
    clear: false,
    reset: false,
    condition: (value) => value.product,
  },
  {
    name: 'clone_sections',
    label: 'Clone Sections',
    type: 'Checkbox',
    className: 'col-span-12 row-span-1 bg-white !px-0',
    labelClassName: 'hidden',
    defaultValue: defaultValues?.is_apply_smoothing || false,
    clear: false,
    reset: false,
    condition: (value) => value.product,
  },
]

export default formView
